import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters'
import auth from './modules/auth';
import state from './state'
import mutations from './mutations'
import vuexPersistedstate from 'vuex-persistedstate'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth
  },
  // state:{
  //   projectName:'润图逸云'
	// },
  state,
  mutations,
  getters,
  plugins: [vuexPersistedstate({storage: window.sessionStorage})]
});



// WEBPACK FOOTER //
// ./src/store/index.js